// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XBcl","footer":"styles_footer__1Un4v","passCodeTooltip":"styles_passCodeTooltip__ILAYh"};